// @ts-check
import { cdate as cdateUTC } from "cdate";

export const cdate = cdateUTC().utcOffset(9).locale("ja").cdateFn();
